import { FunctionComponent, useState } from 'react';
import Image from 'next/image';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import ArticleAuthor from 'types/api/ArticleAuthor';

import ArticleIndex from 'components/content/sections/Articles/ArticleIndex';
import ArticleWrapper from 'components/content/sections/Articles/ArticleWrapper';
import HtmlStyledContent from 'components/layout/HtmlStyledContent';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PageArticlesSectionArticle: FunctionComponent<Props> = ({ translations, article }) => {
    const [imageLoaded, setImageLoaded] = useState<boolean>(false);
    const [darkMode, setDarkMode] = useState<boolean>(false);
    const ARTICLE = article?.data;

    return (
        <StyledComponent className="page-article-section-article">
            <LayoutContainer size={Sizes.Large}>
                <div
                    className={classNames({
                        'change-mode': true,
                        'dark-mode': darkMode,
                    })}
                    onClick={() => {
                        setDarkMode(!darkMode);
                    }}
                >
                    <FontAwesomeIcon
                        icon={faLightbulb}
                        style={{ color: darkMode ? '#7A297D' : 'white' }}
                    />
                </div>
            </LayoutContainer>
            <LayoutContainer size={Sizes.XMedium}>
                <div className={classNames({
                    'article-container': true,
                    'dark-mode': darkMode,
                })}
                >
                    <div className="main-article-data">
                        <div className="main-article-data__title">
                            {ARTICLE?.title}
                        </div>
                        <div className="main-article-data__article-information">
                            <div className="date">
                                {ARTICLE?.publishedAt}
                            </div>
                            <div className="category">
                                {ARTICLE?.category?.name}

                            </div>
                            <div className="author">
                                {ARTICLE?.author?.name || '-'}
                            </div>
                        </div>
                        <div className="main-article-data__article-image">
                            <Image
                                layout="fill"
                                src={ARTICLE?.image?.imageUrl || '/images/home/palceholder_card_image.png'}
                                onLoad={() => imageLoaded ? null : setImageLoaded(true)}
                                alt="article-image"
                            />
                            {imageLoaded && (
                                <Image
                                    className="background"
                                    layout="fill"
                                    src={ARTICLE?.image?.imageUrl || '/images/home/palceholder_card_image.png'}
                                    alt="article-image"
                                    loading="lazy"
                                />
                            )}
                        </div>
                        <div
                            className="main-article-data__content"
                            dangerouslySetInnerHTML={{ __html: ARTICLE?.shortDescription }}
                        />
                    </div>
                    <div className="html-content">
                        <ArticleWrapper article={ARTICLE}>
                            {(content, indexStructure) => {
                                return (
                                    <div className="wrapper-article">
                                        <div className="article">
                                            <div className="article-content">
                                                {indexStructure && Object.keys(indexStructure).length > 0 && (
                                                    <div className="article-content-list">
                                                        <div className="list-headline">
                                                            {translations?.contentList}
                                                        </div>
                                                        <ArticleIndex indexStructure={indexStructure} />
                                                    </div>
                                                )}
                                                <div className="content">
                                                    <HtmlStyledContent html={content} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }}
                        </ArticleWrapper>
                    </div>
                    <ArticleAuthor
                        translations={translations}
                        author={ARTICLE.author}
                    />
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PageArticlesSectionArticle;

const ArticleAuthor: FunctionComponent<{ translations: Record<string, any>, author: ArticleAuthor }> = ({
    translations,
    author,
}) => (
    <div className="article-author">
        <div className="article-author__avatar">
            <img
                src={author?.avatar?.imageUrl}
                alt="avatar"
            />
        </div>
        <div className="article-author__information">
            <span className="article-author__information-section-title">
                Autor artykułu
            </span>
            <div className="article-author__information-name">
                {author?.name}
            </div>
            <div className="article-author__information-bio">
                {author?.bio}
            </div>
        </div>
    </div>
);
